(() => {
  if (customElements.get('giesto-help-panel')) return;

  class GiestoHelpPanel extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.launcher = /** @type {HTMLButtonElement | null} */ (this.querySelector('.gh-help__launcher'));
      this.dialog = this.querySelector('dialog');
      this.closeButton = this.querySelector('.gh-help__close');
      if (!this.launcher || !this.dialog || !this.closeButton || !this.dialog.showModal) return;

      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.launcher.addEventListener('click', () => this.open(), options);
      this.closeButton.addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('close', () => this.restore(), options);
      this.dialog.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab') return;
        const controls = this.dialog.querySelectorAll('a[href], button:not([disabled])');
        const first = /** @type {HTMLElement} */ (controls[0]);
        const last = /** @type {HTMLElement} */ (controls[controls.length - 1]);
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }, options);
      // Native dialog backdrop clicks target the dialog. The panel and floating
      // close button are children, so their clicks cannot dismiss by accident.
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      }, options);
      this.launcher.hidden = false;
    }

    open() {
      if (this.dialog.open) return;
      this.previousOverflow = document.documentElement.style.overflow;
      this.dialog.showModal();
      this.isActive = true;
      document.documentElement.style.overflow = 'hidden';
      this.launcher.setAttribute('aria-expanded', 'true');
      this.launcher.hidden = true;
    }

    restore() {
      if (!this.isActive) return;
      this.isActive = false;
      document.documentElement.style.overflow = this.previousOverflow ?? '';
      this.previousOverflow = undefined;
      this.launcher.hidden = false;
      this.launcher.setAttribute('aria-expanded', 'false');
      this.launcher.focus({ preventScroll: true });
    }

    disconnectedCallback() {
      if (this.dialog?.open) {
        this.dialog.close();
        this.restore();
      }
      this.controller?.abort();
      this.controller = null;
    }
  }

  customElements.define('giesto-help-panel', GiestoHelpPanel);
})();
